<template>
  <div class="row m-0">
    <transition name="fade">
      <payment-popup v-if="isPayNow" @closePay="closePay" :paymentDetails="payOrder"></payment-popup>
    </transition>
    <transition name="fade">
      <div class="row m-0 align-items-center justify-content-center loadingItem" v-if="isProductLoading">
        <grid-loader :loading="isProductLoading" :size="loaderSize"></grid-loader>
      </div>
    </transition>
    <div  class="col-12 p-0 px-md-3 mt-3">
      <div class="row m-0 align-items-center cursor" @click="goBack">
        <div class="col-auto pr-1">
          <ios-arrow-back-icon />
        </div>
        <div class="col-auto p-0 mb-1">
          Back
        </div>
      </div>
      <div class="row m-0">
        <div class="mb-3 col-12">
          <!-- <div class="mb-3 col-12 col-sm-6 col-md-6 col-lg-4 item"> -->
          <div class="row m-0 mb-2 order" v-for="order in sortedOrders" :order="order" :key="order['.key']">
            <div class="col-12 p-0 mb-3 cursor" @click="showOrderDetails(order['.key'])">
              <div class="card w-100">
                <div class="card-body">
                  <div class="row m-0">
                    <div class="col-12 p-0">
                      <h5 class="card-title">
                        {{ order.orderNumber | formatOrdernumber }}:  {{ order.currentStatus }} - {{ order.status[0].startTime | date }}
                      </h5>
                    </div>
                    <div class="col-12 p-0">
                      <div class="row m-0" v-if="order.payment">
                        <div class="col-12 p-0">
                          <p class="card-text">
                            Paid - {{ order.details.paymentMethod}}<br/>
                            {{ order.details.shippingMethod }}
                          </p>
                        </div>
                      </div>
                      <div class="row m-0 align-items-center" v-else>
                        <div class="col p-0">
                          <p class="card-text" >Unpaid - {{ order.details.paymentMethod}}</p>
                        </div>
                        <div class="col-auto p-0">
                          <!-- <button class="btn btn-outline" @click.stop="openPay(order.details)">Pay Now</button>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  components: {
    GridLoader,
    'payment-popup': () => import('@/components/payment/Payment.vue')
  },
  data () {
    return {
      loaderSize: '50px',
      hasDelivery: true,
      isPayNow: false,
      payOrder: {}
    }
  },
  metaInfo () {
    return {
      title: 'Orders Page'
    }
  },
  computed: {
    ...mapGetters(['orders', 'isProductLoading', 'shopDetails', 'shopId']),
    sortedOrders () {
      let arrCopy = this.orders.slice(0)
      return arrCopy.sort((a, b) => {
        if (a.status[0].startTime < b.status[0].startTime) {
          return 1
        } else if (a.status[0].startTime > b.status[0].startTime) {
          return -1
        } else {
          return 0
        }
      })
    }
  },
  methods: {
    showOrderDetails (orderId) {
      this.$router.push(`/order/${orderId}`)
    },
    goBack () {
      this.$router.push(`/${this.shopId}/store`)
    },
    openPay (val) {
      this.isPayNow = true
      this.payOrder = val
    },
    closePay () {
      this.isPayNow = false
    }
  }
}
</script>
